import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { InstallationFeaturesStore } from '@store';
import {
  ActivateDeactivateCommands,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  RoomsStatusProperties,
  SrcPumpControlStatusProperties,
} from '@vi-iot/client/index';
import { DeviceIds } from '@vi-iot/client/models';
import { Observable } from 'rxjs';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-src-settings-pump-control',
  templateUrl: './src-settings-pump-control.component.html',
  styleUrls: ['./src-settings-pump-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsPumpControlComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() status: Feature<RoomsStatusProperties, ActivateDeactivateCommands>;
  @Input() pumpControlIds: string[];
  @Input() pumpControlFeatures: Feature<SrcPumpControlStatusProperties, ActivateDeactivateCommands>;

  extractPumpControlId: string;
  supplyChannelNumber: string;
  readonly featurePropertyKey = FeaturePropertyKey;

  roomStatusFeatureUpdatePending$: Observable<boolean>;

  constructor(
    protected installationFeaturesStore: InstallationFeaturesStore,
    protected translate: TranslateService
  ) {}
  ngOnInit(): void {
    this.extractPumpControlId = this.extractPumpControlIdFromFeature(this.pumpControlFeatures);
    this.supplyChannelNumber = this.printSupplyChannelNumber(this.extractPumpControlId);
  }

  onPumpControlToggle(pumpSwitch: MatSlideToggle, pumpId: string): void {
    const successMessage = this.translate.instant('+SCHEDULES.SNACKBAR.PROGRAM_SUCCESS');

    this.installationFeaturesStore.updateFeature(
      FeatureNames.srcChannelPumpControl(pumpId),
      !pumpSwitch.checked,
      'active',
      '',
      !pumpSwitch.checked ? 'activate' : 'deactivate',
      null,
      DeviceIds.RoomControl,
      {
        successMessage: successMessage,
      }
    );
    this.onPumpControlChange(pumpSwitch);
  }

  private extractPumpControlIdFromFeature(
    feature: Feature<SrcPumpControlStatusProperties, ActivateDeactivateCommands>
  ): string {
    return this.pumpControlIds.find((id) => feature.feature.includes(id));
  }

  private printSupplyChannelNumber(pumpId: string): string {
    return `${parseInt(pumpId) + 1}`;
  }

  onPumpControlChange(pumpToggle: MatSlideToggle): void {
    pumpToggle.toggle();
  }
}
